import React, { useEffect } from 'react'
import {Grid} from 'semantic-ui-react'
import InputField from '../../../commonComponents/formComponents/inputField'
import DropDown from '../../../commonComponents/formComponents/dropDown'
import {ModeOfPayment } from '../util'
import { getValidationError as ValidationError } from '../../Helper';
import { useSelector, useDispatch } from 'react-redux'
import DeleteIcon from '../../../commonComponents/deleteIcon'
import {saveShipmentFieldValue, updateShipmentFieldValue } from '../../actions'
import {  addItemsTabWarnings,deleteItemsTabWarnings,} from '../../../commonActions/serverErrorAction';
import { TAX_TYPE,TAXABLE_BASE,RATE } from '../../Helper/formLabel';
import { useCurrentShipmentType } from '../../../hooks/useCurrentShipmentType'
import CopyRepElement from '../../../GB_App/formSections/itemsTab/copyRepElement'

const MerchandiseDutyDetails = ({item:{taxType,merchandiseId,taxBase,taxRate,taxAmount,merchandiseDutyId},dutyIndex,
  translate,updateItem,saveItem,deleteItem,copyData,isFormDisabled, lineItemIndex,invoiceIndex}) => {
  const formData = useSelector((state) => state.Shipment)
  const taxCodes = useSelector((state) => state.DropDownValues.taxCodes)
  const {isImportShipment,customJobState} = useCurrentShipmentType()
  const dispatch = useDispatch()
  const pdiValidationCheck = customJobState?.includes("PDI");
  const statValue = useSelector(state => state.InvoicesReducer.invoices[invoiceIndex]?.merchandiseList[lineItemIndex]?.statValue) || '0';
  const customValue = useSelector(state => state.InvoicesReducer.invoices[invoiceIndex]?.merchandiseList[lineItemIndex]?.customValue) || '0';

  const calcAmt = (taxBase, taxRate,pl) => {
    if (taxBase === 0 || taxRate === 0) return
    if (taxBase && taxRate) {
      return !pl?((taxBase * taxRate) / 100):taxBase*taxRate
    
    }
  }
  const getValidationError=(field, value, Level, onlyMandatoryCheck)=>ValidationError(field, value, Level, onlyMandatoryCheck,'',translate,pdiValidationCheck)

  const addErrors = (level, value, fieldName) => {
    dispatch(addItemsTabWarnings(level, value, fieldName))
  }
  const deleteErrors = (level, value, fieldName) => {
    dispatch(deleteItemsTabWarnings(level, value, fieldName))
  }

  useEffect(() => {
    if (isImportShipment) {
      const taxTypes = [
        { types: ['B', '3I', '3R'], value: statValue },
        { types: ['A', '3AI'], value: customValue },
      ]

      taxTypes.forEach(({ types, value }) => {
        if (types.some((type) => taxType?.startsWith(type) || taxType?.includes(type))) {
          const amount = taxRate ? calcAmt(value, taxRate) : 0
          const data = { taxBase: value, taxAmount: amount?.toFixed(2) }

          updateItem(merchandiseDutyId, data)
          saveItem({ merchandiseDutyId, ...data })
        }
      })
    }
  }, [taxType, statValue, isImportShipment, customValue, taxRate, merchandiseDutyId])
  console.log('rerendering');
  return (
    <Grid.Row>
      <Grid.Column width={1} style={{ textAlign: 'center' }}>
        <CopyRepElement
          title={`DUTIES_VAT`}
          request={{ merchandiseDutyId: '', taxType, taxBase, taxRate, taxAmount }}
          callback={copyData}
          isFormDisabled={isFormDisabled}
        />
      </Grid.Column>
      <Grid.Column width={4} className='divFormFeild border-bottom b-rw-0'>
        <DropDown
          id={`taxType-${merchandiseId}`}
          label={translate(TAX_TYPE, { ns: ['default', 'lineItem'] })}
          disabled={isFormDisabled}
          className='field-bg dropdown100'
          labelClass='text-none'
          isLabel={true}
          data={taxCodes}
          clearable
          value={taxType}
          errors={isImportShipment && getValidationError('taxType', taxType, 'itemsTab')}
          onChange={(value) => {
            value === '1PL'
              ? (updateItem(merchandiseDutyId, { taxType: value?.trim(), taxRate: '0.45' }),
                saveItem({ merchandiseDutyId, taxType: value, taxRate: '0.45' }))
              : (updateItem(merchandiseDutyId, { taxType: value?.trim() }),
                saveItem({ merchandiseDutyId, taxType: value }))
            let err = isImportShipment ? getValidationError('taxType', value, 'itemsTab') : []
            err.length
              ? addErrors(
                  'itemsTab',
                  `invoice - 00${invoiceIndex + 1} :: line 00${lineItemIndex + 1}.` +
                    ' :: ' +
                    err[0],
                  `taxType-${merchandiseId}-${dutyIndex}`
                )
              : deleteErrors('itemsTab', '', `taxType-${merchandiseId}-${dutyIndex}`)
          }}
        />
      </Grid.Column>
      <Grid.Column width={3} className='divFormFeild border-bottom b-rw-0'>
        <InputField
          isLabel={false}
          id={`taxBase-${merchandiseId}`}
          label={translate(TAXABLE_BASE, { ns: ['default', 'lineItem'] })}
          type='text'
          string={taxType === '1PL' ? 'KN' : '€'}
          addThousandsSeperator={true}
          value={taxBase || ''}
          errors={getValidationError('taxBase', taxBase, 'itemsTab')}
          className={'field-bg'}
          clearInput={false}
          onChange={(value) => {
            let amt = calcAmt(value, taxRate, taxType === '1PL') || 0
            updateItem(merchandiseDutyId, {
              taxBase: value,
              taxAmount: `${amt.toFixed(2)}`,
            })
          }}
          onBlur={(value) => {
            saveItem({ merchandiseDutyId, taxBase: value || ' ', taxAmount: taxAmount })
            let err = getValidationError('taxBase', taxBase, 'itemsTab') 
            err.length
              ? addErrors(
                  'itemsTab',
                  `invoice - 00${invoiceIndex + 1} :: line 00${lineItemIndex + 1}.` +
                    ' :: ' +
                    err[0],
                  `taxBase-${merchandiseId}-${dutyIndex}`
                )
              : deleteErrors('itemsTab', '', `taxBase-${merchandiseId}-${dutyIndex}`)
          }}
          disabled={isFormDisabled}
        />
      </Grid.Column>
      <Grid.Column width={2} className='divFormFeild border-bottom b-rw-0'>
        <InputField
          isLabel={false}
          id={`taxRate-${merchandiseId}`}
          label={
            translate(RATE, { ns: ['default', 'lineItem'] }) +
            `${taxType === '1PL' ? ' (€/KN)' : ' (%)'}`
          }
          type='text'
          value={taxRate || ''}
          errors={getValidationError('taxRate', taxRate || '', 'itemsTab')}
          className={'field-bg dropdown100'}
          clearInput={false}
          onChange={(value) => {
            let amt = calcAmt(taxBase, value) || 0
            updateItem(merchandiseDutyId, {
              taxRate: value,
              taxAmount: `${amt.toFixed(2)}`,
            })
          }}
          onBlur={(value) => {
            saveItem({ merchandiseDutyId, taxRate: value || ' ', taxAmount: taxAmount })
            let err = getValidationError('taxRate', taxRate || '', 'itemsTab') 
            err.length
              ? addErrors(
                  'itemsTab',
                  `invoice - 00${invoiceIndex + 1} :: line 00${lineItemIndex + 1}.` +
                    ' :: ' +
                    err[0],
                  `taxRate-${merchandiseId}-${dutyIndex}`
                )
              : deleteErrors('itemsTab', '', `taxRate-${merchandiseId}-${dutyIndex}`)
          }}
          disabled={isFormDisabled || taxType === '1PL'}
        />
      </Grid.Column>
      <Grid.Column width={2} className='divFormFeild border-bottom b-rw-0'>
        <InputField
          isLabel={false}
          id={`taxAmount-${merchandiseId}`}
          label={translate('AMOUNT', { ns: ['default', 'lineItem'] })}
          type='number'
          string={'€'}
          addThousandsSeperator={true}
          value={taxAmount || '0'}
          className={'field-bg'}
          clearInput={false}
          disabled={true}
        />
      </Grid.Column>
      <Grid.Column width={3} className='divFormFeild border-bottom'>
        <DropDown
          id={`taxType-${merchandiseId}`}
          label={translate('MP', { ns: ['default', 'lineItem'] })}
          disabled={
            isFormDisabled || !(lineItemIndex === 0 && invoiceIndex === 0 && dutyIndex === 0)
          }
          className='field-bg dropdown100'
          labelClass='text-none'
          isLabel={true}
          data={ModeOfPayment}
          clearable
          value={formData?.mopCode}
          onChange={(value) => {
            dispatch(
              updateShipmentFieldValue({
                mopCode: value?.trim(),
              })
            )
            dispatch(saveShipmentFieldValue('mopCode'))
          }}
        />
      </Grid.Column>
      <Grid.Column width={1} className='icon-delete-add-info'>
        <DeleteIcon onClick={() => deleteItem(merchandiseDutyId)} disabled={isFormDisabled} />
      </Grid.Column>
    </Grid.Row>
  )
}

export default React.memo(MerchandiseDutyDetails)